import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import { jwtDecode } from "jwt-decode";
import { userAccountStore } from '@/store/loginStore';
import site from '@/../public/site.json';


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const { user_authorize, supper_authorize } = to.meta;
  const userStore = userAccountStore();
  const supperUserToken = userStore.supperUserToken;

  const userToken = userStore.userToken;
  // const currentUser = userToken ? jwtDecode(userToken) : null;
  
  
  // console.log(userStore.supperUserToken)
  const currentSupperUser = supperUserToken ? jwtDecode(supperUserToken) : null;

  if (user_authorize) {
    if (!userToken) {
      return next({ path: '/Unauthorized' });
    }

    if (user_authorize.length && !user_authorize.includes('text')) {
      return next({ path: '/' })
    }
  }
  
  if (supper_authorize) {
    if (!currentSupperUser) {
      return next({ path: '/dashboard/login' });
    }

    if (supper_authorize.length && !supper_authorize.includes(currentSupperUser.role)) {
      return next({ path: '/dashboard/Unauthorized' })
    }
  }


  next();
  const defaultTitle = site.site.name;
  document.title = to.meta.title || defaultTitle;

});

export default router
